import React, { useEffect } from "react";
import { LanguageProvider, useLanguage } from "./i18n/LanguageContext";
import { ThemeProvider, useTheme } from "./theme/ThemeContext";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { CustomCursor } from "./components/common/CustomCursor";
import { Hero } from "./components/sections/Hero";
import { Skills } from "./components/sections/Skills";
import { Projects } from "./components/sections/Projects";
import { Experience } from "./components/sections/Experience";
import { Education } from "./components/sections/Education";
// Certifications temporarily hidden until real certifications are available.
// import { Certifications } from "./components/sections/Certifications";
import { Support } from "./components/sections/Support";
import { Contact } from "./components/sections/Contact";

function DocumentMeta() {
  const { t } = useLanguage();
  const { theme } = useTheme();

  useEffect(() => {
    document.title = t.meta.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", t.meta.description);
  }, [t]);

  useEffect(() => {
    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) themeColor.setAttribute("content", theme === "dark" ? "#05070a" : "#f6f7f9");
  }, [theme]);

  return null;
}

function AppContent() {
  return (
    <div className="App">
      <DocumentMeta />
      <div className="noise-layer" />
      <CustomCursor />
      <Navbar />
      <main>
        <Hero />
        <Skills />
        <Projects />
        <Experience />
        <Education />
        {/* <Certifications /> */}
        <Support />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
